import React from 'react';
import styled from 'styled-components';
const Icon = styled.svg`
  width: 25px;
  height: 25px;
`;
export default (() => /*#__PURE__*/React.createElement(Icon, {
  width: "25",
  height: "25",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-label": "ondertiteling"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  transform: "translate(2 4)",
  fillRule: "evenodd",
  d: "M0 0h21v16H0V0zm2 8v2h4V8H2zm13 4v2h4v-2h-4zM2 12v2h11v-2H2zm6-4v2h11V8H8z",
  id: "a"
})));